// StaffStats.jsx
import { Popover } from "antd";
import shiftAccept from "../../../../../assets/svg/shiftAccept.svg";
import shiftAsterisk from "../../../../../assets/svg/shiftAsterisk.svg";

const Staff = ({ val }) => {
  const isUnderstaffed = val?.stats?.understaffed;

  return (
    <div className="flex items-center">

      {/* Approved Staff */}
      <Popover
        placement="top"
        content={
          <span className="text-black text-[13px] font-medium">
            Staff confirmed
          </span>
        }
        overlayClassName="event-shift-popover"
      >
        <div className="flex mr-1">
          <img src={shiftAccept} alt="shift-send" className="mr-[6px]" />
          <span
            className={`text-[13px] font-bold ${
              isUnderstaffed ? "text-darkRed" : "text-algae"
            }`}
          >
            {val?.stats?.approved}
          </span>
        </div>
      </Popover>

      {/* Separator */}
      <span className="text-silverGray mx-1">/</span>

      {/* Required Staff */}
      <Popover
        placement="top"
        content={
          <span className="text-black text-[13px] font-medium">
            Staff needed
          </span>
        }
        overlayClassName="event-shift-popover"
      >
        <div className="flex">
          <img src={shiftAsterisk} alt="shift-send" className="mr-[6px]" />
          <span
            className={`text-[13px] font-bold ${
              isUnderstaffed ? "text-darkRed" : "text-algae"
            }`}
          >
            {val?.talent_needed}
          </span>
        </div>
      </Popover>

    </div>
  );
};

export default Staff;
